module.exports = __webpack_public_path__ + "img/wedo_pict05.19f2c332.png";